<div class="relationship-view-main-container mb-5">
  <div class="relationship-view-container" *ngIf="jounrnyList.length > 0  && !isAPIError && !isLoading">
    <ul class="ltms-tabs">
      <li class="ltms-tab" [ngClass]="{'ltms-active-tab': activeTab.key == tab.key}" *ngFor="let tab of tabs" (click)="changeTab(tab)">{{tab.name}}</li>
      <li class="ltms-tab ltms-tab-right" (click)="showEditJourneyModal()">
        <img src="./assets/images/settings.svg" alt="setting-icon">
      </li>
    </ul>
    <div class="relationship-tab-content" *ngIf="activeTab.key == 'highlights'">
      <app-highlights />
    </div>
    <div class="relationship-tab-content" *ngIf="activeTab.key == 'customer_journey'">
      <app-customer-journey />
    </div>
  </div>
  <div class="relationship-view-container" *ngIf="jounrnyList.length == 0 && !isAPIError && !isLoading">
    <div class="define-journey-container">
      <app-create-journey />
    </div>
  </div>
  <div class="page-frame" *ngIf="isLoading">
    <app-ltms-loader></app-ltms-loader>
  </div>
  <div class="page-frame error-page" *ngIf="isAPIError && !isLoading">
    <div class="error-message">{{errorMessage}}</div>
  </div>
</div> 

<app-create-journey *ngIf="isEditJourneyModal" [isEditMode]="true" (closeModal)="closeEditJourneyModal()"></app-create-journey>